import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.lg};
`;
